import React, { useState, forwardRef, useImperativeHandle } from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
} from '@material-ui/core';
import { useSnackbar } from 'notistack';

import { api } from '../../services';

const DialogDownloadXml = forwardRef(
  ({ handleCloseNotification = () => {} }, ref) => {
    const { enqueueSnackbar } = useSnackbar();

    const [open, setOpen] = useState(false);
    const [chave, setChave] = useState('');
    const [loading, setLoading] = useState(false);

    useImperativeHandle(ref, () => ({
      handleOpen(chaveInicial) {
        setOpen(true);
        if (chaveInicial) setChave(chaveInicial);
      },
    }));

    const handleClose = () => {
      setOpen(false);
      setChave('');
      handleCloseNotification('');
    };

    const handleChange = (e) => {
      const somenteNumeros = e.target.value.replace(/\D/g, '');
      setChave(somenteNumeros);
    };

    const handleExecutar = async () => {
      if (chave.length !== 44) {
        enqueueSnackbar('A chave deve conter 44 dígitos', {
          variant: 'warning',
        });
        return;
      }

      try {
        setLoading(true);

        const { data } = await api.put(`/forcar_downloads_xml/${chave}`);

        if (!data.status) {
          enqueueSnackbar(data.message || 'Erro ao processar', {
            variant: 'error',
          });
          return;
        }

        enqueueSnackbar(data.message || 'Solicitação realizada com sucesso', {
          variant: 'success',
        });

        handleClose();
      } catch (err) {
        enqueueSnackbar(err.response?.data?.message || 'Erro na requisição', {
          variant: 'error',
        });
      } finally {
        setLoading(false);
      }
    };

    return (
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Buscar XML da NFe de Compra</DialogTitle>

        <DialogContent>
          <TextField
            label="Chave de acesso (44 dígitos)"
            fullWidth
            variant="outlined"
            value={chave}
            onChange={handleChange}
            inputProps={{
              maxLength: 44,
              inputMode: 'numeric',
            }}
            style={{ marginTop: 10 }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') handleExecutar();
            }}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} disabled={loading}>
            Cancelar
          </Button>

          <Button
            onClick={handleExecutar}
            color="primary"
            variant="contained"
            disabled={loading || chave.length !== 44}
          >
            {loading ? <CircularProgress size={24} /> : 'Buscar XML'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  },
);

export default DialogDownloadXml;
